// extracted by mini-css-extract-plugin
module.exports = {"blue":"ClearIcon-module--blue--e3843d","grey":"ClearIcon-module--grey--f2f1fd"};